import { render } from "./BlockDex.vue?vue&type=template&id=1f62210f&scoped=true"
import script from "./BlockDex.vue?vue&type=script&lang=js"
export * from "./BlockDex.vue?vue&type=script&lang=js"

import "./BlockDex.vue?vue&type=style&index=0&id=1f62210f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f62210f"]])

export default __exports__